import axios from "axios";

// En producción, nginx ya hace proxy_pass de /api al backend correcto para
// CADA dominio (cada tenant clonado corre en su propio puerto -- 8000, 8001,
// etc. -- ver sites-available/*.conf), así que una ruta relativa "/api" es
// lo correcto ahí: mismo build funciona para cualquier tienda sin tocar nada.
// Adivinar el puerto (":8000" fijo) rompía cualquier tenant que no fuera
// justo el puerto 8000 -- pasó de verdad con Jose Store (corre en 8001):
// su sitio caía en silencio al tenant de respaldo y mostraba la marca de
// MQ Store en vez de la suya.
// En desarrollo local (yarn start, sin nginx de por medio) sí hace falta
// adivinar el host:puerto del backend, porque no hay proxy reverso.
// REACT_APP_BACKEND_URL sigue como escape hatch explícito para cualquier
// caso especial (frontend y backend en hosts distintos).
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  || (process.env.NODE_ENV === "development" ? `${window.location.protocol}//${window.location.hostname}:8000` : "");
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Algunos navegadores embebidos (el navegador interno de Telegram/WhatsApp en
// celular, modo privado, etc.) bloquean localStorage y lanzan una excepción
// real al tocarlo -- sin este try/catch esa excepción tumbaba el render
// entero (pantalla en blanco) apenas se cargaba la app. Con el respaldo en
// memoria la sesión al menos funciona mientras dura la pestaña.
let memoryToken = null;
export function readToken() {
  try { return localStorage.getItem("mq_token"); } catch { return memoryToken; }
}
export function writeToken(token) {
  memoryToken = token;
  try { localStorage.setItem("mq_token", token); } catch { /* sin persistencia disponible */ }
}
export function clearToken() {
  memoryToken = null;
  try { localStorage.removeItem("mq_token"); } catch { /* sin persistencia disponible */ }
}

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
